<template>
  <div class="m750">
    <div class='appSnocck'>
      <img src="https://images.zhibo.tv/2021/0708/rechargeH5.png" alt="">
      <div class="btn" @click="handleClick"></div>
    </div>
    <div class="shade">
      <div class="dialog">
        <div class="tishi">提示</div>
        <div class="info">【IOS用户可在支付宝“中国体育”生活号内或登录PC端中国体育ZHIBO.TV官方网站www.zhibo.tv参与活动】</div>
        <div class="line"></div>
        <div class="yesBtn" onclick="document.getElementsByClassName('shade')[0].style.display='none'">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      browser: ''
    }
  },
  created(){
    this.browser = {
      versions: this.zhongduan(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }
    window.console.log(this.browser)
    try {
      window.webkit.messageHandlers.changeTitle.postMessage('喜迎奥运 激情一夏 充值狂欢季')
    } catch (e) {
      window.console.log(0)
    }
    try {
      window.LiveAppJS.changeTitle('喜迎奥运 激情一夏 充值狂欢季')
    } catch (e) {
      window.console.log(1)
    }
  },
  methods: {
    //判断访问终端
    zhongduan () {
      var u = navigator.userAgent
      // var  app = navigator.appVersion
      return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == " qq" //是否QQ
      }
    },
    handleClick() {
      //判断是否移动端
      if (this.browser.versions.ios) {
        document.getElementsByClassName('shade')[0].style.display='block'
      } else {
        var token = this.getcommit('token')
        if (token) {
          // 调打开充值页面
          //  alert("调打开充值页面");
          window.console.log("调打开充值页面");
          try {
            window.LiveAppJS.startRecharge();
          } catch (e) {
            window.console.log('error')
          }
        } else {
          // 登录
          // alert("登录");
          window.console.log('登录');
          try {
            window.LiveAppJS.login();
          } catch (e) {
            window.console.log('error')
          }
        }
      }

    },

    getcommit(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.appSnocck {
  position: relative;
}

.appSnocck img {
  display: block;
  width: 100vw;
}

.appSnocck .btn {
  width: 75%;
  height: 4%;
  background: transparent;
  position: absolute;
  bottom: 2%;
  left: 13%;
}

.shade {
  display: none;
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}

.shade .dialog {
  width: 5.4rem;
  height: 3.2rem;
  padding: 0.36rem 0.3rem 0 0.3rem;
  box-sizing: border-box;
  background: rgba(252, 252, 252);
  border-radius: 0.24rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.shade .dialog .tishi {
  color: #030303;
  text-align: center;
  font-size: 0.34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 0.48rem;
}

.shade .dialog .info {
  margin-top: 0.16rem;
  margin-bottom: 0.36rem;
  font-size: 0.26rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(3, 3, 3, 1);
  line-height: 0.32rem;
}

.shade .dialog .line {
  width: 5.4rem;
  height: 0.01rem;
  background: rgba(77, 77, 77, 0.78);
  position: absolute;
  left: 0;
}

.shade .dialog .yesBtn {
  text-align: center;
  font-size: 0.34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0076FF;
  line-height: 0.88rem;
}
</style>